module.exports = __webpack_public_path__ + "img/gallery-8.d2471ec9.png";